import { updateFormErrors } from "../helper/updateFormErrors";
import Customer from '../model/Customer';
import { removeFormSubmitStatus } from "../helper/removeFormSubmitStatus";

const UserControlService = function (dateFilter, $timeout) {
    var service = {
        /**
         * @type {Customer}
         */
        customer: {},

        oldCustomerValues: null,

        formValidation: {
            modelOptions: {
                debounce: 600
            },
            email: {
                ngPattern: /^.+@.+\..{2,}$/
            },
            vorname: {
                max: 60,
                ngPattern: /^.*[a-zäöü]+.*[a-zäöü]+.*$/i
            },
            nachname: {
                max: 60,
                ngPattern: /^.*[a-zäöü]+.*[a-zäöü]+.*$/i
            },
            street: {
                max: 60
            },
            streetNumber: {
                ngPattern: /^.*[a-z0-9]+.*$/i
            },
            addressAddition: {
                max: 60
            },
            companyAddress: {
                max: 60
            },
            postcode: {
                max: 10,
                ngPattern: /^.*$/
            },
            postcodeDel: {
                max: 10,
                ngPattern: /^.*$/
            },
            area: {
                max: 60
            },
            tel: {
                max: 30,
                ngPattern: /^(([0+])([0-9\+\s-]{2,})){0,1}$/
            },
            birthday: {
                day: {
                    ngPattern: /^(0[1-9]|1[0-9]|2[0-9]|3[01])$/
                },
                month: {
                    ngPattern: /^(0[1-9]|1[012])$/
                },
                year: {
                    ngPattern: /^[0-9]{4}$/
                },
                ngPattern: /^(0[1-9]|1[0-9]|2[0-9]|3[01])\.(0[1-9]|1[012])\.[0-9]{4}$/
            }
        },

        passwordResetSuccess: false,
        showPasswordError: false,
        registerSuccess: false,

        formStatus: {
            'userKnown': false, // Indicates if a user is known to the system - identified by mail
            'userNotKnown': false, // We don't know this email address. This is different from !userKnown !!!
            'userLoggedIn': false, // Indicates if a user is logged in
            'loginMode': false, // Indicates that the user wants to log in
            'updateMode': false, // Indicates that the user wants to update its address data
            'amazonMode': false, // Indicates that the user wants to log in via amazon
            'registerMode': false, // Indicates that the user wants to register
            'guestMode': false, // User wants to make this purchase as a guest
            'guestLoggedIn': false, // Indicates if user is logged in as a guest
            'addressIncomplete': false, // Indicates that the address of a customer is not set yet
        },

        exeStatus: {
            resetPassword: 0
        },

        /**
         * 0 = not allowed
         * 1 = yes, but default is guest
         * 2 = yes, but default is register
         *
         * @type number
         */
        guestMode: 0,
        /**
         * @param {Customer} data
         */
        createCustomer: function (data) {
            if (!data.birthday) {
                data.birthday = {};
            }
            if (!data.hasvalidationwarning) {
                data.hasvalidationwarning = 0;
            }
            this.customer = new Customer(data);
        },

        /**
         * @param {'userKnown'|'userNotKnown'|'userLoggedIn'|'loginMode'|'updateMode'|'amazonMode'|'registerMode'|'guestMode'|'guestLoggedIn'|'addressIncomplete'} mode
         * @param value
         */
        updateFormStatus: function (mode, value) {
            if (typeof this.formStatus[ mode ] !== 'undefined' && typeof value !== 'undefined') {
                this.formStatus[ mode ] = value;
                this.deprecated.$scope.formStatus[ mode ] = value;
            }
        },
        /**
         * @param {'userKnown'|'userNotKnown'|'userLoggedIn'|'loginMode'|'updateMode'|'amazonMode'|'registerMode'|'guestMode'|'guestLoggedIn'|'addressIncomplete'} mode
         * @return {null|boolean}
         */
        getFormStatus: function (mode) {
            return typeof this.formStatus[ mode ] !== 'undefined' ? this.formStatus[ mode ] : null;
        },

        /**
         * @param {Customer} customerData
         */
        initCustomer: function (customerData) {

            if (typeof prefilledReservationEmail !== "undefined") {
                customerData.email = prefilledReservationEmail;
            }

            this.createCustomer(customerData);
            customerData.hasvalidationwarning = this.checkIfCustomerHasWarnings(false);
            if (this.customer.status === 3 && this.customer.vorname == undefined) {
                this.setFormUpdateMode(true);
                this.updateFormStatus('addressIncomplete', true);
            }
            this.updateCustomerData(customerData);
        },

        /**
         * @param {Customer} customerData
         */
        updateCustomerData: function (customerData) {

            if (customerData.geburtsdatum) {
                customerData.birthday = {
                    day: dateFilter(customerData.geburtsdatum, 'dd'),
                    month: dateFilter(customerData.geburtsdatum, 'MM'),
                    year: dateFilter(customerData.geburtsdatum, 'yyyy')
                };
                customerData.geburtsdatum = dateFilter(customerData.geburtsdatum, 'dd.MM.yyyy');
            }
            this.customer.update(customerData);

            // Set Different Delivery Address
            this.customer.diffDeliveryAddress = !this.getCopyinv();

            // Check if customer is logged in
            this.updateFormStatus('userLoggedIn', customerData.id);

            if (typeof gtmHelper === 'object' && customerData.id && !amazonLoggedIn) {
                gtmHelper.pushCheckout(2, 'logged in');
            }
        },

        getCopyinv: function () {
            return ((typeof this.customer.copyinv === "undefined") || this.customer.copyinv === null || this.customer.copyinv === 1 || this.customer.copyinv === true || this.customer.copyinv === "true" || this.customer.copyinv === "1");
        },

        setCopyinv: function (attr) {
            if (attr) {
                this.customer.copyinv = "1";
            } else {
                this.customer.copyinv = "0";
            }
        },

        /**
         * @param {'plz'|'plz_del'} mode
         * @param {number} minValue
         * @param fieldToTriggerChange
         */
        checkPostalCodeCity: function (mode, minValue, fieldToTriggerChange) {
            var postcodeRequest = this.customer.plz;

            if (mode === 'plz_del') {
                postcodeRequest = this.customer.plz_del;
            }

            if (postcodeRequest && postcodeRequest.length >= minValue) {
                var that = this;
                that.deprecated.$scope.ajaxCall('purchase', 'checkpostcode', 'POST', { 'postcode': postcodeRequest }, function (response) {
                    if (response && response.place) {
                        if (mode === 'plz_del') {
                            that.customer.ort_del = response.place;
                        } else {
                            that.customer.ort = response.place;
                        }
                        if (fieldToTriggerChange) {
                            var elementToTrigger = angular.element(fieldToTriggerChange);
                            if (elementToTrigger) {
                                elementToTrigger.trigger('change');
                            }
                        }
                    }
                }, function (error) {
                    that.deprecated.$scope.displayError(error);
                });
            }
            this.clearWarning(mode);
        },

        setDefaultCountry: function () {
            if (!this.customer.land) {
                this.customer.land = "DEU";
            }
            if (!this.customer.land_del) {
                this.customer.land_del = "DEU";
            }
        },

        // Required hack ?? ~@bernd
        setStatesOfCountry: function (country) {
            if (this.customer.state) {
                var old_state = this.customer.state;
                this.customer.state = this.deprecated.$scope.states[ country ][ 0 ];
                this.customer.state = old_state;

            }
            if (this.customer.state_del) {
                var old_state_del = this.customer.state_del;
                this.customer.state_del = this.deprecated.$scope.states[ country ][ 0 ];
                this.customer.state_del = old_state_del;
            }
        },

        setLoginMode: function (value) {
            this.updateFormStatus('loginMode', value);
        },
        setRegisterMode: function (value) {
            this.updateFormStatus('registerMode', value);
        },

        setFormUpdateMode: function (value) {
            this.updateFormStatus('updateMode', value);
        },
        setAmazonMode: function (value) {
            this.updateFormStatus('amazonMode', value);
        },
        logout: function () {
            var that = this;
            var $scope = this.deprecated.$scope;

            window.localStorage.login = 0;
            $scope.ajaxCall('login', 'logout', 'GET', null, function (data) {
                if (data.status === 1) {
                    // Reset Customer Object Set Germany as default
                    if (!that.getFormStatus('guestLoggedIn')) {
                        that.createCustomer({});
                        that.setDefaultCountry();
                    }
                    that.setLoginMode(false);
                    that.updateFormStatus('userLoggedIn', false);
                    that.updateFormStatus('userKnown', false);
                    that.updateFormStatus('updateMode', false);
                    that.updateFormStatus('amazonMode', false);
                    that.updateFormStatus('guestLoggedIn', false);
                    that.updateFormStatus('registerForPaymentMode', false);
                    that.updateFormStatus('loginForPaymentMode', false);

                    that.debit = {};
                    removeFormSubmitStatus();
                    document.querySelectorAll('.formerror:not([ng-show])').forEach(function (el) { el.textContent = ''; });
                    $scope.loginSubmitAttempted = false;
                    if ($scope.register_email_form) {
                        $scope.register_email_form.$setPristine();
                        $scope.register_email_form.$setUntouched();
                    }
                    if ($scope.login_form) {
                        $scope.login_form.$setPristine();
                        $scope.login_form.$setUntouched();
                    }
                    $scope.updateCheckoutOptions();
                    $timeout(function () {
                        var mailInput = document.getElementById('mail');
                        if (mailInput) {
                            mailInput.focus();
                        }
                    });
                }
            });
        },
        cancelLogin: function () {
            // Truncate the password - so we're not having any issues when the customer decides to checkout as guest
            this.customer.password = null;
            this.customer.loginRequired = false;
            this.updateFormStatus('loginMode', false);
        },

        //  Login-Formular
        validateLoginForm: function () {
            var that = this;
            var $scope = this.deprecated.$scope;
            $scope.loginSubmitAttempted = true;
            ['login-form', 'register-email-form'].forEach(function (id) {
                var formObj = document.getElementById(id);
                if (formObj && !formObj.classList.contains('submit')) {
                    formObj.classList.add('submit');
                }
            });
            $scope.ajaxCall('login', 'login', 'POST', this.customer, function (data) {
                if (data.id) {
                    window.localStorage.login = 1;

                    that.updateCustomerData(data);
                    $scope.getStatesContentData(that.customer.land);
                    $scope.getStatesContentData(that.customer.land_del);

                    that.showPasswordError = false;
                    $scope.pendingFocusAfterLogin = true;
                    $scope.updateCheckoutOptions();
                    if (typeof gtmHelper === 'object') {
                        gtmHelper.pushCheckout(2, 'fresh login');
                    }

                    if (typeof gtmCheckout === 'object') {
                        gtmCheckout.resetRegisteredCount();
                        gtmCheckout.genericEvents();
                    }

                    if ($scope.formStatus.loginForPaymentMode) {
                        $scope.setDebitPayment();
                    }
                    $scope.showPaymentOptions = true;
                } else {
                    that.showPasswordError = true;
                    const invalidInputs = document.querySelectorAll('#login-form.submit input:invalid, #register-email-form.submit input:invalid');
                    const firstInvalid = Array.from(invalidInputs).find(function (input) {
                        return input.offsetParent !== null;
                    });
                    if (firstInvalid) {
                        firstInvalid.focus();
                    }
                    else {
                        var pwField = document.getElementById('input-login-password');
                        if (pwField) {
                            pwField.focus();
                        }
                    }
                }
            });
        },

        switchForm: function () {
            var that = this;
            // setTimeout to give time for the angular lifecycle
            // it may be to early to update the customer-data
            return $timeout(function () {
                that.checkIfCustomerHasWarnings(true);

                if (that.getFormStatus('updateMode')) {
                    that.updateCustomer();
                    return;
                }
                if (that.getFormStatus('registerMode')) {
                    that.registerCustomer();
                    return;
                }
                that.updateFormStatus('guestMode', true);
                that.registerCustomer();
            }, 0);
        },

        /**
         * @param {boolean} showModal Flag if modal shall be shown on warning (defaults true)
         * @return {number} 0 or 1
         */
        checkIfCustomerHasWarnings: function (showModal) {
            var $scope = this.deprecated.$scope;
            var customerObject = this.customer;
            $scope.activeWarnings = [];

            var checkMap = {
                vorname: {
                    max: 40,
                    regEx: /^[^0-9]+$/
                },
                nachname: {
                    max: 40,
                    regEx: /^[^0-9]+$/
                },
                nr: {
                    max: 5,
                    regEx: /^[A-Za-z0-9 ]+$/
                },
                ort: {
                    max: 60,
                    regEx: /^[^0-9]+$/
                },
                vorname_del: {
                    max: 40,
                    regEx: /^[^0-9]+$/
                },
                nachname_del: {
                    max: 40,
                    regEx: /^[^0-9]+$/
                },
                nr_del: {
                    max: 5,
                    regEx: /^[A-Za-z0-9 ]+$/
                },
                ort_del: {
                    max: 60,
                    regEx: /^[^0-9]+$/
                }
            };

            Object.keys(checkMap).forEach(function (key) {
                if (customerObject.diffDeliveryAddress === false && key.substring(key.length - 4) === '_del') {
                    // Skip validation of delivery address if delivery address has no different to invoice address
                    return;
                }
                if (customerObject.hasOwnProperty(key) && customerObject[ key ] != null &&
                    (customerObject[ key ].length > checkMap[ key ].max || !customerObject[ key ].match(checkMap[ key ].regEx))) {
                    $scope.activeWarnings.push(key);
                }
            });

            var values = {};
            Object.keys(customerObject).forEach(function (key) {
                if (customerObject.diffDeliveryAddress === false && key.substring(key.length - 4) === '_del') {
                    // Skip validation of delivery address if delivery address has no different to invoice address
                    return;
                }
                var currentValue = customerObject[ key ];
                if (currentValue === null || currentValue === false || currentValue === '' || [ 'copyinv', 'hasvalidationwarning', 'emailRepeat', 'loginRequired', 'registerRequired', 'passwordConfirm', 'birthday', 'geburtsdatum', 'balance', 'turnover', 'status', 'languageid', 'clientid' ].indexOf(key) > -1) {
                    return;
                }
                if (values[ currentValue ]) {
                    values[ currentValue ].count++;
                    values[ currentValue ].keys.push(key);
                } else {
                    values[ currentValue ] = {
                        count: 1,
                        keys: [ key ]
                    };
                }
            });
            var acceptedDuplicatesCount = (customerObject.diffDeliveryAddress === false) ? 1 : 2;
            var duplicates = Object.keys(values).map(function (key) {
                return values[ key ];
            }).filter(function (value) {
                return value.count > acceptedDuplicatesCount;
            });

            if (duplicates.length > 0) {
                duplicates.forEach(function (val) {
                    $scope.activeWarnings = $scope.activeWarnings.concat(val.keys);
                });
            }
            if ($scope.activeWarnings.length > 0) {
                this.customer.hasvalidationwarning = 1;
                this.customer.warnings = $scope.activeWarnings;
                if (showModal) {
                    $scope.showAddressValidationWarning = true;

                    setTimeout(function () {
                        document.getElementById('addressValidationWarning-modal').showModal();
                        requestAnimationFrame(function () {
                            document.getElementById('addressValidationWarning-modal-title').focus();
                        });
                    }, 100);
                }
            }
            return this.customer.hasvalidationwarning;
        },

        clearWarning: function (key) {
            var $scope = this.deprecated.$scope;
            var indexOfKey = $scope.activeWarnings.indexOf(key);
            if (indexOfKey > -1) {
                $scope.activeWarnings.splice(indexOfKey, 1);
            }
        },

        registerCustomer: function () {
            var $scope = this.deprecated.$scope;
            var copyinv = !this.customer.diffDeliveryAddress;
            this.setCopyinv(copyinv);


            var validateFrm = this.validateCustomerForm(this.customer.diffDeliveryAddress);

            if (validateFrm === false) {
                return false;
            }

            var that = this;

            var oldCustomerCountry = '';
            if (that.oldCustomerValues !== null) {
                oldCustomerCountry = (that.oldCustomerValues.copyinv === '1') ? that.oldCustomerValues.land
                    : that.oldCustomerValues.land_del;
            }

            $scope.ajaxCall('login', 'register', 'POST', this.customer, function (data) {
                if (data.error) {
                    $scope.displayError(data.error);
                    that.registerSuccess = data.error;
                } else if (data.message) {
                    window.localStorage.login = 1;

                    var newCustomerCountry = (data.customer.copyinv === '1') ? data.customer.land
                        : data.customer.land_del;
                    if (that.oldCustomerValues !== null) {
                        if (newCustomerCountry === oldCustomerCountry) {
                            $scope.setIsDelCountryChanged(0);
                        } else {
                            $scope.setIsDelCountryChanged(1);
                        }
                    }
                    that.oldCustomerValues = data.customer;

                    that.registerSuccess = true;
                    that.createCustomer(data.customer);
                    $scope.pendingFocusAfterLogin = true;
                    if (that.getFormStatus('guestMode')) {
                        that.updateFormStatus('guestLoggedIn', true);
                        if (typeof gtmHelper === 'object') {
                            gtmHelper.pushCheckout(2, 'guest login');
                        }
                    } else {
                        that.updateFormStatus('userLoggedIn', true);
                    }

                    that.customer.diffDeliveryAddress = !that.getCopyinv();

                    if ($scope.formStatus.registerForPaymentMode) {
                        $scope.setDebitPayment();
                    }
                    $scope.showPaymentOptions = true;
                    $scope.updateCheckoutOptions();

                } else {
                    $scope.displayError("login error");

                }

            });
        },

        validateCustomerForm: function (differentDeliveryAddress) {
            var $scope = this.deprecated.$scope;
            var formIDs = [ 'register-form' ];
            if (differentDeliveryAddress) {
                formIDs.push('register-copyinv-form');
            } // Add Delivery Form if different delivery Address
            if (this.getFormStatus('registerMode')) {
                formIDs.push('form-register-password'); // Add password form if in register mode
            }
            if (!this.getFormStatus('updateMode')) {
                formIDs.push('register-email-form');
            }
            var validates = true;

            formIDs.forEach(function (formID) {
                var formObj = document.getElementById(formID);
                formObj.className += " submit";
                var formScope = angular.element(formObj).scope();
                if (!formObj.checkValidity() || formScope && formScope[ formObj.name ].$invalid) {
                    validates = false;
                }
                updateFormErrors(formID);
            });
            if (!validates) {
                $scope.scrollTo('#register');
                // A11y: collect all invalid fields across all forms, sort them by their actual
                // DOM position (not by formIDs order) and focus the first one, so keyboard and
                // screen-reader users are brought directly to the first error on the page.
                var invalidFields = [];
                formIDs.forEach(function (formID) {
                    var formEl = document.getElementById(formID);
                    if (!formEl) return;
                    formEl.querySelectorAll('input, select').forEach(function (field) {
                        if (!field.validity.valid) {
                            invalidFields.push(field);
                        }
                    });
                });
                if (invalidFields.length > 0) {
                    invalidFields.sort(function (a, b) {
                        return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
                    });
                    invalidFields[0].focus();
                }
            }
            return validates;
        },

        updateCustomer: function () {
            var validateFrm = this.validateCustomerForm(this.customer.diffDeliveryAddress);
            if (validateFrm === true) {
                var $scope = this.deprecated.$scope;
                var that = this;
                this.setCopyinv(!this.customer.diffDeliveryAddress);
                $scope.ajaxCall('login', 'update', 'POST', this.customer, function (data) {
                    if (data.error) {
                        $scope.displayError(data.error);
                    } else if (data.message) {
                        $scope.setIsDelCountryChanged(data.isDelCountryChanged);
                        $scope.pendingFocusAfterLogin = true;
                        $scope.updateCheckoutOptions();
                        that.updateFormStatus('updateMode', false);
                    }
                });

            }
        },

        revertToGuest: function () {
            this.updateFormStatus('registerMode', false);
            this.updateFormStatus('guestMode', true);
        },

        resetPassword: function () {
            var $scope = this.deprecated.$scope;
            if (!this.exeStatus.resetPassword) {
                this.exeStatus.resetPassword = 2;
                var that = this;

                $scope.ajaxCall('login', 'resetpassword', 'POST', { email: this.customer.email }, function (response) {
                    that.exeStatus.resetPassword = 0;

                    if (typeof response.error !== 'undefined') {
                        $scope.displayError(response.error);
                    } else if (typeof response.message !== 'undefined') {
                        that.passwordResetSuccess = true;
                    }
                });
            }
        },
        resetState: function () {
            this.customer.state = null;
        },
        resetStateDel: function () {
            this.customer.state_del = null;
        },

        updateBirthday: function () {
            if (this.customer.birthday.day || this.customer.birthday.month || this.customer.birthday.year) {

                this.customer.geburtsdatum = dateFilter(this.customer.birthday.day + '.' + this.customer.birthday.month + '.' + this.customer.birthday.year, 'dd.MM.yyyy');
            } else {
                this.customer.geburtsdatum = '';
            }
        },

        /**
         * @param {number} mode
         */
        guestAllowedMode: function (mode) {
            this.guestMode = parseInt(mode);
        },

        /**
         * @return {boolean}
         */
        isGuestAllowed: function () {
            return this.guestMode !== 0;
        },

        deprecated: { $scope: null }
    };

    service.factory = function ($scope) {
        service.deprecated.$scope = $scope;

        /**
         * @todo should be put in a payment-controller
         * @return {boolean}
         */
        $scope.validateCCForm = function () {
            if ($scope.Cart.paymentMethod.identifier === "cc" || $scope.Cart.paymentMethod.identifier === "hdp_cc") {
                var formID = "register-form-cc";
            } else {
                return true;
            }
            var formObj = document.getElementById(formID);
            formObj.className += " submit";
            var valid = formObj.checkValidity();
            updateFormErrors(formID);
            return valid;
        };
    };
    return service;
};

export default UserControlService;
